function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#1ED46A",
  fillRule: "evenodd",
  d: "M57 13.511l12.31 7.718c.46.228.69.685.69 1.142 0 .218-.052.436-.157.629H70v42a2 2 0 01-2 2H2a2 2 0 01-2-2V23h.157A1.323 1.323 0 010 22.371c0-.457.23-.914.69-1.142L13 13.51V10a2 2 0 012-2h7.657L33.897.715a2 2 0 012.197.014L47.01 8H55a2 2 0 012 2v3.511zm0 3.155v11.45l9.086-5.745L57 16.666zm-2.779 13.208V11.733a1 1 0 00-1-1h-6.433l-.156.267-.403-.267H23.647l-.05.033-.023-.033h-6.795a1 1 0 00-1 1v18.141L35 42.029l19.221-12.155zM13 28.117V16.666L3.914 22.37 13 28.117zM42.114 8L35 3.277 27.808 8h14.306zM2.754 24.81v38.44a1 1 0 001 1h62.492a1 1 0 001-1V24.819L35.69 44.77c0 .229-.23.229-.46.229-.231 0-.461 0-.692-.229L2.754 24.811zM36.5 18h8a1.5 1.5 0 010 3h-8a1.5 1.5 0 010-3zm-11 0h3a1.5 1.5 0 010 3h-3a1.5 1.5 0 010-3zm17 6h2a1.5 1.5 0 010 3h-2a1.5 1.5 0 010-3zm-17 0h10a1.5 1.5 0 010 3h-10a1.5 1.5 0 010-3zm0 7h19a1.5 1.5 0 010 3h-19a1.5 1.5 0 010-3z"
});

var SvgIcoCheckEmail = function SvgIcoCheckEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 67,
    viewBox: "0 0 70 67",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoCheckEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-check-email.ff5c37dd.svg";
export { ForwardRef as ReactComponent };